import { createModel } from '@rematch/core';
import {
  StateType, RecordIDModel, defaults, CRUDReducers,
} from '@equifinance/shared';
import { RootModel } from '.';

const props = [
  'applicantIncome',
  'propertyValue',
  'firstChargeBalance',
  'firstChargeMonthlyRepayments',
  'totalUnsecuredBalance',
  'loanRequired',
  'term',
] as const;
export type Calculator = RecordIDModel<typeof props[number]>

const calculatorModel = createModel<RootModel>()({
  state: {
    0: defaults<Calculator>(props),
  } as StateType<Calculator>,
  reducers: {
    ...CRUDReducers<Calculator>(props),
  },
  selectors: (slice) => ({
    maxLoan() {
      return slice((calculator) => calculator[0].applicantIncome || 'NA');
    },
    requiredLoan() {
      return slice((calculator) => calculator[0].applicantIncome || 'NA');
    },
    ltv() {
      return slice((calculator) => calculator[0].applicantIncome || 'NA');
    },
    monthlyRepayment() {
      return slice((calculator) => calculator[0].applicantIncome || 'NA');
    },
  }),
});

export default calculatorModel;
